import { render, staticRenderFns } from "./manifest.vue?vue&type=template&id=f909f6f0&scoped=true&"
import script from "./manifest.vue?vue&type=script&lang=js&"
export * from "./manifest.vue?vue&type=script&lang=js&"
import style0 from "./manifest.vue?vue&type=style&index=0&id=f909f6f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f909f6f0",
  null
  
)

export default component.exports